<template>
  <el-row>
    <el-col>
      <h2>View & Change Division Access</h2>
      <el-dialog title="Add/Update Division Access"
        :visible.sync="addFormVisible">
        UserName: <el-input v-model="userName"></el-input>
        <br /><br />
        Division: <all-division-dropdown v-model="peaDivisionId" :inputModel="peaDivisionId"></all-division-dropdown>
        <br /><br />
        Can View: <el-checkbox v-model="canView" @change="updateCanView()"></el-checkbox>
        <br /><br />
        <span class="ml-n4">Is Admin:</span> <el-checkbox v-model="makeAdmin" @change="updateCanView()"></el-checkbox>
        <br /><br />
        <button class="btn btn-success" @click="update()">Update Division Access</button>
      </el-dialog>
      <el-row>
        <el-col>
          View Division Access for User: <user-drop-down :inputModel="selectedUserId" v-model="selectedUserId" :clearable="true" />
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col>
          <el-alert v-if="alertTitle !== ''"
            :title="alertTitle"
            :type="alertType"
            :description="callInfo"
            :closable="false"
            show-icon>
          </el-alert>
          <el-button class="btn btn-primary" @click="search()">Show Division Access</el-button>
          <el-button class="btn btn-success" @click="showPopup()">Add Division Access</el-button>
        </el-col>
      </el-row>
      <el-table ref="dataTable" v-if="showTable" :data="tableData" @row-click="selectRow" v-loading="tableLoading">
        <el-table-column align="left" style="word-wrap:normal"
          prop="divisionName"
          label="Division Name">
        </el-table-column>
        <el-table-column prop="canView" align="left"
          label="Can View">
          <template slot-scope="props">
            <el-checkbox v-model="props.row.canView" :disabled="true"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="userIsAdmin" align="left"
          label="Is Admin">
          <template slot-scope="props">
            <el-checkbox v-model="props.row.userIsAdmin" :disabled="true"></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
      <br/>
    </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
import userDropDown from '@/components/utility/userDropDown.vue'

export default {
  name: 'adminDivisionAccess',
  components: {
    userDropDown
  },
  data () {
    return {
      userName: '',
      selectedUserId: null,
      isLoading: false,
      alertType: '',
      alertTitle: '',
      callInfo: '',
      tableData: [{}],
      columns: Array,
      tableLoading: true,
      showTable: false,
      peaDivisionId: '',
      makeAdmin: false,
      addFormVisible: false,
      canView: false
    }
  },
  methods: {
    async loadUserName () {
      if (!this.selectedUserId) {
        this.userName = ''
        return
      }

      try {
        const res = await this.$axios.get(`/PEAUser/${this.selectedUserId}`)
        this.userName = res.data.userName || ''
      } catch (err) {
        this.userName = ''
        helperMethods.showNotification(this, 'Error finding user', err.body || err.message, 'error', 10000)
      }
    },
    showPopup () {
      this.peaDivisionId = ''
      this.makeAdmin = false
      this.canView = false
      this.addFormVisible = true
    },
    updateCanView () {
      if (this.makeAdmin) {
        this.canView = true
      }
    },
    selectRow: function (row) {
      if (row !== null) {
        this.peaDivisionId = row.divisionId
        this.canView = row.canView
        this.makeAdmin = row.userIsAdmin
        this.addFormVisible = true
      }
    },
    async search () {
      await this.loadUserName()
      this.alertTitle = ''
      if (!this.userName) {
        helperMethods.showNotification(this, 'Select a user', 'Select a user', 'error', 15000)
      } else {
        this.showTable = true
        this.tableLoading = true
        var call = '/getDivAccess/' + this.userName
        this.$axios.get(call).then(response => {
          this.tableData = response.data
          this.tableLoading = false
        }).catch(reject => {
          this.tableLoading = false
          this.tableData = null
          this.resultTotal = 0
          this.showTable = false
          helperMethods.showNotification(this, 'Error Retrieving Division Access', reject.body, 'error', 30000)
        })
      }
    },
    async update () {
      await this.loadUserName()
      this.addFormVisible = false
      var call = '/addDivisionAccess/' + this.userName + '?divisionId=' + this.peaDivisionId + '&makeAdmin=' + this.makeAdmin + '&canView=' + this.canView
      this.$axios.post(call).then(response => {
        this.isLoading = false
        this.search()
        helperMethods.showNotification(this, 'Division Access Added', response.body, 'success', 10000)
      })
        .catch(reject => {
          this.isLoading = false
          helperMethods.showNotification(this, 'Error adding access', reject.body, 'error', 30000)
        })
    }
  },
  mounted () {
    if (this.$attrs.userName) {
      this.userName = this.$attrs.userName
      this.search()
    }
  }
}
</script>
